import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { RespiAllerValueType } from '@common/enums';
import type { RespiAllerGradingDataV1 } from './respiAllerGradingDataV1';
import {
    diagnosticReportKeysOptional,
    diagnosticReportKeysRequired,
    respiAllerValidIcd10Codes,
} from './respiAllerGradingDataV1';

const saveGradingResultRequestBodyValidation = Koi.array()
    .items(
        ...Object.values(diagnosticReportKeysRequired).map((diagnosticReportKey) =>
            Koi.object({
                type: diagnosticReportKey,
                value: Koi.string()
                    .max(10_000)
                    .when('type', {
                        is: RespiAllerValueType.icd10,
                        otherwise: Koi.string().max(10_000).required(),
                        then: Koi.string()
                            .valid(...respiAllerValidIcd10Codes)
                            .required(),
                    })
                    .required(),
            }).required()
        ),
        ...Object.values(diagnosticReportKeysOptional).map((diagnosticReportKey) =>
            Koi.object({
                type: diagnosticReportKey,
                value: Koi.string().max(10_000).required(),
            }).optional()
        )
    )
    .unique('type')
    .min(Object.values(diagnosticReportKeysRequired).length)
    .max(Object.values(diagnosticReportKeysRequired).length + Object.values(diagnosticReportKeysOptional).length)
    .error((errors) => {
        errors.forEach((error) => {
            if (error.local?.value?.type && error.local?.label) {
                error.path = [error.local.value.type];
                error.local.label = error.local.value.type;
            }
        });

        return errors;
    });

const respiAllerGradingFinal: TypedSchema<RespiAllerGradingDataV1> = {
    conclusie: respiAllerGradingKoiValue(RespiAllerValueType.conclusie),
    dossiersamenvatting: respiAllerGradingKoiValue(RespiAllerValueType.dossiersamenvatting),
    'icd-10': Koi.string()
        .valid(...respiAllerValidIcd10Codes)
        .required(),
    individuele_aanbevelingen: respiAllerGradingKoiValue(RespiAllerValueType.individueleAanbevelingen),
    medicamenteus_advies: respiAllerGradingKoiValue(RespiAllerValueType.medicamenteusAdvies),
    niet_medicamenteus_advies: respiAllerGradingKoiValue(RespiAllerValueType.nietMedicamenteusAdvies),
    opmerkingen_voor_huisarts: respiAllerGradingKoiValue(RespiAllerValueType.opmerkingenVoorHuisarts),
};

export const saveGradingResultRequestBodySchema = saveGradingResultRequestBodyValidation.options({
    allowUnknown: true,
    convert: false,
});
export const respiAllerGradingDraftSchema = Koi.object({});
export const respiAllerGradingFinalSchema = Koi.object(respiAllerGradingFinal).options({
    allowUnknown: true,
    convert: false,
});

function respiAllerGradingKoiValue(key: RespiAllerValueType) {
    if (diagnosticReportKeysRequired.includes(key)) {
        return Koi.string().max(10_000).required();
    } else {
        return Koi.string().max(10_000).optional();
    }
}
